import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  OutlinedInput,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { SET_FINAL_PAY } from "../../Pages/CheckoutPage";
import {
  getItemOffer,
  getOfferDetails,
  matchOffersToItems,
  sumOfferSavings,
} from "../../Utils/orderTotals";
import {
  AccountBalanceWalletOutlined,
  CheckCircleOutline,
  CloseRounded,
  CreditCardOutlined,
  KeyboardArrowDown,
  KeyboardArrowUp,
  LocalAtmOutlined,
  PaymentsOutlined,
  PointOfSaleOutlined,
  PrintOutlined,
  ReceiptLongOutlined,
} from "@mui/icons-material";
import ReactToPrint from "react-to-print";
import { useUpdateOrderMutation } from "../../Store/Services/CheckoutService";
import {
  clearSelectedCustomer,
  selectCustomer,
} from "../../Store/Slices/customerSlice";
import { clearGlobalCartId } from "../../Utils/cartSession";

export const SummeryPaper = ({
  items,
  checkoutData,
  dispatch,
  enableDelivery = false,
  orderDet,
  currency,
}) => {
  const [result, setResult] = useState();
  const [viewTax, setViewTax] = useState(false);
  const [viewCharge, setViewCharge] = useState(false);
  const currencyRate = parseFloat(currency?.currencyRate) || 1;
  const currencySymbol = currency?.currencySymbol || "$";
  const toNumber = (value) => parseFloat(value) || 0;

  // totAmt is the pre-discount subtotal; offerDetails explain the drop to totPay.
  const offerSavings = sumOfferSavings(orderDet);

  useEffect(() => {
    if (checkoutData) {
      const coupon = result?.off
        ? Math.round(parseFloat(result?.off).toFixed(2) * 100) / 100
        : 0;
      dispatch({
        type: SET_FINAL_PAY,
        payload: {
          totAmt:
            Math.round(parseFloat(orderDet?.totAmt || 0).toFixed(2) * 100) /
            100,
          totTax:
            Math.round(parseFloat(orderDet?.totTax || 0).toFixed(2) * 100) /
            100,
          totOff:
            Math.round(parseFloat(orderDet?.totOff || 0).toFixed(2) * 100) /
            100,
          totChg:
            Math.round(parseFloat(orderDet?.totChg || 0).toFixed(2) * 100) /
            100,
          delCost:
            Math.round(
              parseFloat(
                checkoutData?.deliveryOptionPrice || orderDet?.delCost || 0
              ).toFixed(2) * 100
            ) / 100,
          totPay:
            Math.round(
              parseFloat(
                result?.off
                  ? orderDet?.totPay +
                      checkoutData?.deliveryOptionPrice -
                      coupon || orderDet?.totPay - coupon
                  : orderDet?.totPay + checkoutData?.deliveryOptionPrice ||
                      orderDet?.totPay
              ).toFixed(2) * 100
            ) / 100,
          currency: (currency?.currencySymbol || "$"),
          couponAmount:
            Math.round(parseFloat(result?.off || 0).toFixed(2) * 100) / 100,
          taxDetails: orderDet?.taxDetails?.map((tax) => ({
            tax: tax.tax,
            taxAmt: Math.round(parseFloat(tax.taxAmt).toFixed(2) * 100) / 100,
            taxId: tax.taxId,
          })),
          chargeDetails: orderDet?.chargeDetails?.map((chg) => ({
            charge: chg.charge,
            chargeAmt:
              Math.round(parseFloat(chg.chargeAmt).toFixed(2) * 100) / 100,
            chargeId: chg.chargeId,
          })),
        },
      });
    }
  }, [orderDet, result]);

  return (
    <Paper variant="none" square style={{ padding: "0.5rem" }}>
      <div style={{ marginBlock: "1rem" }}>
        <div
          style={{
            display: "flex",
            marginLeft: "1rem",
            justifyContent: "space-between",
            marginBottom: "0.3rem",
          }}
        >
          <Typography style={{ color: "#707070" }}>
            Subtotal ({items?.length} {items?.length == 1 ? "item" : "items"})
          </Typography>
          <Typography fontWeight="bold" style={{ color: "#707070" }}>
            {currencySymbol}{" "}
            {(toNumber(orderDet?.totAmt) * currencyRate).toFixed(2)}{" "}
          </Typography>
        </div>
        {orderDet?.totTax !== 0 ? (
          <div>
            {viewTax ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "0.3rem",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <IconButton
                    style={{ width: "1rem", height: "1rem" }}
                    onClick={() => setViewTax(!viewTax)}
                    aria-label="tax"
                  >
                    {!viewTax ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
                  </IconButton>
                  <Typography style={{ color: "#707070" }}>
                    Total Tax
                  </Typography>
                </div>
              </div>
            ) : null}
            {viewTax
              ? orderDet?.taxDetails?.map(
                  (tax) =>
                    tax.taxAmt !== 0 && (
                      <div
                        key={tax.taxId}
                        style={{
                          display: "flex",
                          width: "70%",
                          marginLeft: "3rem",
                          justifyContent: "space-between",
                          marginBottom: "0.3rem",
                        }}
                      >
                        <Typography style={{ color: "#707070" }}>
                          {tax.tax}
                        </Typography>
                        <Typography style={{ color: "#707070" }}>
                          {currencySymbol}{" "}
                          {(
                            toNumber(tax?.taxAmt) *
                            currencyRate
                          ).toFixed(2)}
                        </Typography>
                      </div>
                    )
                )
              : null}
            {viewTax ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "0.3rem",
                }}
              >
                <div></div>
                <Typography fontWeight="bold" style={{ color: "#707070" }}>
                  {currencySymbol}{" "}
                  {(toNumber(orderDet?.totTax) * currencyRate).toFixed(2)}
                </Typography>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "0.3rem",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <IconButton
                    style={{ width: "1rem", height: "1rem" }}
                    onClick={() => setViewTax(!viewTax)}
                    aria-label="tax"
                  >
                    {!viewTax ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
                  </IconButton>
                  <Typography style={{ color: "#707070" }}>
                    Total Tax
                  </Typography>
                </div>
                <Typography fontWeight="bold" style={{ color: "#707070" }}>
                  {currencySymbol}{" "}
                  {(
                    toNumber(orderDet?.totTax) *
                    currencyRate
                  ).toFixed(2)}
                </Typography>
              </div>
            )}
          </div>
        ) : null}
        {offerSavings > 0 ? (
          <div
            style={{
              display: "flex",
              marginLeft: "1rem",
              justifyContent: "space-between",
              marginBottom: "0.3rem",
            }}
          >
            <Typography style={{ color: "#707070" }}>
              Discounts ({getOfferDetails(orderDet).length})
            </Typography>
            <Typography fontWeight="bold" style={{ color: "#1f7a45" }}>
              −{currencySymbol} {(offerSavings * currencyRate).toFixed(2)}
            </Typography>
          </div>
        ) : null}
        {checkoutData?.totOff ? (
          <div
            style={{
              display: "flex",
              marginLeft: "1rem",
              justifyContent: "space-between",
              marginBottom: "0.3rem",
            }}
          >
            <Typography style={{ color: "#707070" }}>Total Offer</Typography>
            <Typography fontWeight="bold" style={{ color: "#707070" }}>
              ({currencySymbol}{" "}
              {(
                toNumber(orderDet?.totOff) *
                currencyRate
              ).toFixed(2)}
              )
            </Typography>
          </div>
        ) : null}
        {(result?.off || orderDet?.coupon) && (
          <div
            style={{
              display: "flex",
              marginLeft: "1rem",
              justifyContent: "space-between",
              marginBottom: "0.3rem",
            }}
          >
            <Typography style={{ color: "#707070" }}>
              Coupon (
              {checkoutData?.couponCode || orderDet?.coupon[0]?.couponCode})
            </Typography>
            <Typography fontWeight="bold" style={{ color: "#707070" }}>
              ({currencySymbol}{" "}
              {(
                toNumber(
                  checkoutData?.couponAmount ||
                    orderDet?.couponAmount ||
                    result?.off ||
                    0
                ) * currencyRate
              ).toFixed(2)}
              )
            </Typography>
          </div>
        )}
        {orderDet?.totChg !== 0 ? (
          <div>
            {viewCharge ? (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <IconButton
                    style={{ width: "1rem", height: "1rem" }}
                    onClick={() => setViewCharge(!viewCharge)}
                    aria-label=" Total Charge"
                  >
                    {!viewCharge ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
                  </IconButton>
                  <Typography style={{ color: "#707070" }}>
                    Total Charge
                  </Typography>
                </div>
              </div>
            ) : null}
            {viewCharge
              ? orderDet?.chargeDetails?.map(
                  (chg) =>
                    chg.chargeAmt !== 0 && (
                      <div
                        key={chg.chargeId}
                        style={{
                          display: "flex",
                          width: "70%",
                          marginLeft: "3rem",
                          justifyContent: "space-between",
                          marginBottom: "0.3rem",
                        }}
                      >
                        <Typography style={{ color: "#707070" }}>
                          {chg.charge}
                        </Typography>
                        <Typography style={{ color: "#707070" }}>
                          {currencySymbol}{" "}
                          {(
                            toNumber(chg?.chargeAmt) *
                            currencyRate
                          ).toFixed(2)}
                        </Typography>
                      </div>
                    )
                )
              : null}
            {viewCharge ? (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div></div>
                <Typography fontWeight="bold" style={{ color: "#707070" }}>
                  {currencySymbol}{" "}
                  {(
                    toNumber(orderDet?.totChg) *
                    currencyRate
                  ).toFixed(2)}
                </Typography>
              </div>
            ) : (
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <IconButton
                    style={{ width: "1rem", height: "1rem" }}
                    onClick={() => setViewCharge(!viewCharge)}
                    aria-label="Total Charge"
                  >
                    {!viewCharge ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
                  </IconButton>
                  <Typography style={{ color: "#707070" }}>
                    Total Charge
                  </Typography>
                </div>
                <Typography fontWeight="bold" style={{ color: "#707070" }}>
                  {currencySymbol}{" "}
                  {(
                    toNumber(orderDet?.totChg) *
                    currencyRate
                  ).toFixed(2)}
                </Typography>
              </div>
            )}
          </div>
        ) : null}
      </div>
    </Paper>
  );
};

export const Total = ({ 
  orderDet, 
  totWithOff, 
  delivery = 0, 
  currency, 
  items = [] 
}) => {

  const toNumber = (value) => parseFloat(value) || 0;

  const currencyRate = parseFloat(currency?.currencyRate) || 1;

  const currencySymbol = currency?.currencySymbol || "$";
  
  const subtotal = (items || []).reduce(
    (sum, item) => sum + toNumber(item?.amt) * toNumber(item?.qty),
    0
  );
  const totalTax = toNumber(orderDet?.totTax);
  const totalCharges = toNumber(orderDet?.totChg);
  const totalOffer = toNumber(orderDet?.totOff);
  const couponAmount = toNumber(orderDet?.couponAmount);

  // The API's totPay is the amount to collect; compute locally only if it is absent.
  const computedPayable =
    subtotal + totalTax + totalCharges + toNumber(delivery) - totalOffer - couponAmount;
  const payableBase =
    typeof totWithOff !== "undefined" && totWithOff !== null
      ? toNumber(totWithOff)
      : orderDet?.totPay !== undefined && orderDet?.totPay !== null
        ? toNumber(orderDet.totPay)
        : computedPayable;

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        paddingInline: "1rem",
        paddingBlock: "0.65rem",
        background: "linear-gradient(135deg, #eef4ff 0%, #f6f9ff 100%)",
        borderTop: "1px solid #d8e4f3",
        borderBottom: "1px solid #d8e4f3",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Typography
          variant="h6"
          fontWeight="bold"
          style={{ color: "#173258", fontSize: "1.05rem" }}
        >
          Total Payment
        </Typography>
        <Typography
          variant="body1"
          style={{ color: "#6f84a4", fontSize: "0.82rem" }}
        >
          Inclusive of taxes
        </Typography>
      </div>
      <Typography
        variant="h6"
        fontWeight="bold"
        color="primary"
        style={{ fontSize: "1.18rem" }}
      >
        {currencySymbol}{" "}
        {(toNumber(payableBase) * currencyRate).toFixed(2)}
      </Typography>
    </div>
  );
};

const OrderSummery = ({ items, orderDet, cartId }) => {
const [updateOrder] = useUpdateOrderMutation();
const dispatch = useDispatch();
const { selectedCustomer } = useSelector(selectCustomer);
const currency = {
  currencySymbol:
    typeof window !== "undefined"
      ? sessionStorage.getItem("currencySymbol")
      : "AED",

  currencyRate:
    typeof window !== "undefined"
      ? Number(sessionStorage.getItem("currencyRate")) || 1
      : 1,
};

const currencySymbol = currency.currencySymbol;

  const [openCheckoutDialog, setOpenCheckoutDialog] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState("cash");
  const [cashInput, setCashInput] = useState("0.00");
  const printRef = useRef(null);

  const toNumber = (value) => parseFloat(value) || 0;

const currencyRate =
  typeof window !== "undefined"
    ? parseFloat(sessionStorage.getItem("currencyRate")) || 1
    : 1;

  const subtotal = (items || []).reduce(
    (sum, item) => sum + toNumber(item?.amt) * toNumber(item?.qty),
    0
  );
  const totalTax = toNumber(orderDet?.totTax);
  const totalCharges = toNumber(orderDet?.totChg);
  const totalOffer = toNumber(orderDet?.totOff);
  const couponAmount = toNumber(orderDet?.couponAmount);
  // API figures: totAmt is the pre-discount subtotal, offerDetails the per-item
  // discounts, totPay the amount to collect. Compute locally only if totPay is absent.
  const apiSubtotal = toNumber(orderDet?.totAmt);
  const offerSavings = sumOfferSavings(orderDet);
  const dialogOffers = matchOffersToItems(items, orderDet);
  const discountTotal = (offerSavings > 0 ? offerSavings : totalOffer) + couponAmount;
  const payableAmount =
    orderDet?.totPay !== undefined && orderDet?.totPay !== null
      ? Math.max(0, toNumber(orderDet.totPay))
      : Math.max(0, subtotal + totalTax + totalCharges - totalOffer - couponAmount);
  // Amounts above are in base currency. The cashier types cash in the displayed
  // currency, so balance and quick amounts are computed in display currency and
  // must not be multiplied by currencyRate again when rendered.
  const payableDisplay = Math.round(payableAmount * currencyRate * 100) / 100;
  const paymentAmount = toNumber(cashInput);
  const balance = selectedPayment === "cash" ? paymentAmount - payableDisplay : 0;
  // Quick-tender buttons: the exact total, then the next round amounts a customer
  // is likely to hand over (next 10, 50, 100, 500, 1000...), without duplicates.
  const quickAmounts = (() => {
    const amounts = [payableDisplay];
    const steps = [10, 50, 100, 500, 1000, 5000, 10000];
    for (const step of steps) {
      const rounded = Math.ceil(payableDisplay / step) * step;
      if (rounded > amounts[amounts.length - 1] + 0.004) amounts.push(rounded);
      if (amounts.length === 4) break;
    }
    // If the total is already round, pad with the next multiples of the last step.
    let step = steps[steps.findIndex((s) => s >= (amounts[1] || 10) - payableDisplay)] || 10;
    while (amounts.length < 4) {
      const next = amounts[amounts.length - 1] + step;
      if (!amounts.some((a) => Math.abs(a - next) < 0.004)) amounts.push(next);
      step *= 2;
    }
    return amounts;
  })();
  const printedAt = new Date();

    const resolveCustomerId = () => {
      const fromState =
        selectedCustomer?.custId ||
        selectedCustomer?.customerId ||
        selectedCustomer?.id;

      if (fromState) {
        return fromState;
      }

      if (typeof window === "undefined") {
        return null;
      }

      try {
        const stored = sessionStorage.getItem("posCustomer");
        if (!stored) {
          return null;
        }
        const parsed = JSON.parse(stored);
        return parsed?.custId || null;
      } catch {
        return null;
      }
    };

  const handleCashInputChange = (event) => {
    const value = event.target.value;
    if (value === "" || /^\d+(\.\d{0,2})?$/.test(value) || /^\d*\.\d{0,2}$/.test(value)) {
      setCashInput(value);
    }
  };

  const handleCashInputBlur = () => {
    setCashInput(toNumber(cashInput).toFixed(2));
  };

  const handleCheckout = () => {
    if (typeof window !== "undefined") {
      if (items?.length != 0) {
        if (items?.find((item) => item?.outOfStock === 1)) {
          toast.error(
            "Some items are out of stock. Remove them before checkout!",
            { position: "bottom-right" }
          );
        } else {
          setSelectedPayment("cash");
          setCashInput(payableDisplay.toFixed(2));
          setOpenCheckoutDialog(true);
        }
      } else {
        toast.error("Add Items to Bill!", { position: "bottom-right" });
      }
    }
  };

  useEffect(() => {
    const handleOpenCheckoutPopup = () => {
      handleCheckout();
    };

    window.addEventListener("pos:open-checkout-popup", handleOpenCheckoutPopup);
    return () => {
      window.removeEventListener("pos:open-checkout-popup", handleOpenCheckoutPopup);
    };
  }, [items, orderDet, payableDisplay]);

  return (
    <>
      <SummeryPaper
        items={items}
        disableCoupon
        orderDet={orderDet}
        currency={currency}
      />
      <Total orderDet={orderDet} currency={currency} items={items} />
      <Button
        variant="contained"
        fullWidth
        style={{
          borderRadius: "0 0 10px 10px",
          fontWeight: "bold",
          textTransform: "none",
          fontSize: "0.96rem",
          background: "linear-gradient(135deg, #22439c, #2d6eaf)",
          minHeight: "44px",
        }}
        onClick={() => handleCheckout()}
        aria-label="Checkout"
      >
        Proceed to Checkout
      </Button>

      <Dialog
        open={openCheckoutDialog}
        onClose={() => setOpenCheckoutDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: { xs: 2, md: 3 },
            border: "1px solid #e2eaf7",
            background: "linear-gradient(180deg, #f7faff 0%, #ffffff 45%)",
            overflow: "hidden",
            maxHeight: { xs: "92vh", md: "88vh" },
            display: "flex",
            flexDirection: "column",
          },
        }}
      >
        <DialogTitle
          sx={{
            px: { xs: 1.8, md: 3 },
            py: { xs: 1.3, md: 1.6 },
            borderBottom: "1px solid #e8eef8",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 1,
            background: "rgba(255, 255, 255, 0.88)",
            backdropFilter: "blur(4px)",
          }}
        >
          <div>
            <Typography sx={{ fontWeight: 900, fontSize: { xs: "1.24rem", md: "1.6rem" }, color: "#1d2e4f" }}>
              Complete Payment
            </Typography>
            <Typography sx={{ color: "#6f83a7", fontSize: { xs: "0.85rem", md: "0.92rem" } }}>
              Confirm method, collect payment, and finish this sale
            </Typography>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: "0.55rem" }}>
            {cartId && (
              <Typography
                sx={{
                  px: 1.15,
                  py: 0.35,
                  borderRadius: 6,
                  background: "#eaf1ff",
                  color: "#2a4f9c",
                  fontWeight: 800,
                  fontSize: "0.88rem",
                  whiteSpace: "nowrap",
                }}
              >
                {`#INV-${String(cartId).padStart(6, "0")}`}
              </Typography>
            )}
            <IconButton onClick={() => setOpenCheckoutDialog(false)} aria-label="Close payment popup">
              <CloseRounded fontSize="small" />
            </IconButton>
          </div>
        </DialogTitle>
        <DialogContent
          sx={{
            px: { xs: 1.8, md: 3 },
            py: { xs: 1.6, md: 2.3 },
            overflowY: "auto",
          }}
        >
          <Grid container spacing={2.1}>
            <Grid item xs={12} md={6}>
              <div
                style={{
                  border: "1px solid #deE8F8",
                  borderRadius: 14,
                  background: "#ffffff",
                  padding: "1rem",
                  boxShadow: "0 12px 26px rgba(31, 56, 96, 0.08)",
                }}
              >
                <Typography sx={{ mb: 1.2, fontWeight: 800, color: "#22314b" }}>
                  Payment Method
                </Typography>

                <Grid container spacing={1.3} sx={{ mb: 2 }}>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant={selectedPayment === "cash" ? "contained" : "outlined"}
                      onClick={() => setSelectedPayment("cash")}
                      startIcon={<LocalAtmOutlined />}
                      sx={{
                        textTransform: "none",
                        minHeight: 54,
                        fontSize: "1rem",
                        borderRadius: 1.5,
                        borderColor: "#d1def4",
                        background:
                          selectedPayment === "cash"
                            ? "linear-gradient(135deg, #1f4ca6 0%, #2f6bff 100%)"
                            : undefined,
                      }}
                    >
                      Cash
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant={selectedPayment === "card" ? "contained" : "outlined"}
                      onClick={() => setSelectedPayment("card")}
                      startIcon={<CreditCardOutlined />}
                      sx={{
                        textTransform: "none",
                        minHeight: 54,
                        fontSize: "1rem",
                        borderRadius: 1.5,
                        borderColor: "#d1def4",
                        background:
                          selectedPayment === "card"
                            ? "linear-gradient(135deg, #1f4ca6 0%, #2f6bff 100%)"
                            : undefined,
                      }}
                    >
                      Card
                    </Button>
                  </Grid>
                </Grid>

                <Typography sx={{ mb: 0.8, fontWeight: 700, color: "#22314b" }}>
                  Cash Received
                </Typography>
                <TextField
                  fullWidth
                  value={cashInput}
                  onChange={handleCashInputChange}
                  onBlur={handleCashInputBlur}
                  type="number"
                  disabled={selectedPayment !== "cash"}
                  InputProps={{
                    startAdornment: (
                      <Typography sx={{ mr: 1.2, color: "#536583", fontWeight: 700 }}>
                        {currencySymbol}
                      </Typography>
                    ),
                    sx: {
                      borderRadius: 1.5,
                      minHeight: 66,
                      fontSize: "1.95rem",
                      fontWeight: 800,
                      color: "#1f4ca6",
                      background: selectedPayment === "cash" ? "#f8fbff" : "#fafbfd",
                    },
                  }}
                  sx={{ mb: 1.2 }}
                />

                <div
                  style={{
                    borderRadius: 10,
                    padding: "0.58rem 0.82rem",
                    background: balance >= 0 ? "#edf8f0" : "#fff2f2",
                    border: `1px solid ${balance >= 0 ? "#c4e7cc" : "#f0c7c7"}`,
                    color: balance >= 0 ? "#1f7a45" : "#aa3434",
                    fontWeight: 700,
                    marginBottom: "0.95rem",
                  }}
                >
                  {selectedPayment === "cash"
                    ? `Change to return: ${currencySymbol} ${Math.max(0, balance).toFixed(2)}`
                    : `Change to return: ${currencySymbol} 0.00`}
                </div>

                <Grid container spacing={1.1} sx={{ mb: 1.4 }}>
                  {quickAmounts.map((amount, index) => (
                    <Grid item xs={6} sm={3} key={index}>
                      <Button
                        fullWidth
                        variant="outlined"
                        onClick={() => setCashInput(amount.toFixed(2))}
                        sx={{
                          textTransform: "none",
                          borderRadius: 1.25,
                          borderColor: "#d2def5",
                          color: "#22439c",
                          fontWeight: 700,
                        }}
                      >
                        {currencySymbol} {amount.toFixed(2)}
                      </Button>
                    </Grid>
                  ))}
                </Grid>

              </div>
            </Grid>

            <Grid item xs={12} md={6}>
              <div
                ref={printRef}
                style={{
                  border: "1px solid #dfe8f7",
                  borderRadius: 14,
                  padding: 16,
                  background: "#fff",
                  boxShadow: "0 12px 26px rgba(31, 56, 96, 0.08)",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: 10,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <ReceiptLongOutlined style={{ color: "#264f99" }} />
                    <Typography sx={{ fontWeight: 900, color: "#213a6d" }}>
                      Sale Summary
                    </Typography>
                  </div>
                  {cartId && (
                    <Typography
                      sx={{
                        px: 1.1,
                        py: 0.2,
                        borderRadius: 4,
                        background: "#eaf1ff",
                        color: "#2a4f9c",
                        fontWeight: 800,
                      }}
                    >
                      {`#INV-${String(cartId).padStart(6, "0")}`}
                    </Typography>
                  )}
                </div>
                <Divider sx={{ mb: 1.2 }} />

                <Typography sx={{ fontWeight: 800, color: "#1b2a46", mb: 1 }}>
                  Current Sale
                </Typography>
                <div style={{ marginBottom: 10, maxHeight: 250, overflowY: "auto", paddingRight: 4 }}>
                  {(items || []).map((item, index) => {
                    const qty = toNumber(item?.qty);
                    const unit = toNumber(item?.amt);
                    const lineTotal = qty * unit;
                    const offer = getItemOffer(dialogOffers, item, index);
                    return (
                      <div
                        key={item?.orderDetId || item?.prodDefId || item?.title}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1.5fr auto auto auto",
                          gap: 8,
                          alignItems: "center",
                          padding: "8px 2px",
                          borderBottom: "1px solid #f0f2f8",
                          fontSize: "0.92rem",
                        }}
                      >
                        <span style={{ color: "#23324f", minWidth: 0 }}>
                          {item?.title}
                          {offer && (
                            <span style={{ display: "block", fontSize: "0.76rem", color: "#1f7a45" }}>
                              {offer.offerName || "Discount"}
                              {offer.offerPercentage ? ` (${Number(offer.offerPercentage)}%)` : ""}
                              {" · "}−{currencySymbol}{" "}
                              {((Number(offer.savedAmount) || 0) * currencyRate).toFixed(2)}
                            </span>
                          )}
                        </span>
                        <span style={{ color: "#556b8f" }}>{currencySymbol} {(unit * currencyRate).toFixed(2)}</span>
                        <span style={{ color: "#2b3d62", fontWeight: 700 }}>x {qty}</span>
                        <span style={{ color: "#1a2b4a", fontWeight: 700 }}>
                          {currencySymbol} {(lineTotal * currencyRate).toFixed(2)}
                        </span>
                      </div>
                    );
                  })}
                </div>

                <div style={{ display: "grid", gap: 10 }}>
                  <Typography sx={{ display: "flex", justifyContent: "space-between" }}>
                    <span>
                      <PointOfSaleOutlined
                        sx={{ fontSize: 17, verticalAlign: "text-bottom", mr: 0.8 }}
                      />
                      Subtotal
                    </span>
                    <strong>{currencySymbol} {(apiSubtotal * currencyRate).toFixed(2)}</strong>
                  </Typography>
                  <Typography sx={{ display: "flex", justifyContent: "space-between" }}>
                    <span>
                      <PaymentsOutlined
                        sx={{ fontSize: 17, verticalAlign: "text-bottom", mr: 0.8 }}
                      />
                      Tax
                    </span>
                    <strong>{currencySymbol} {(totalTax * currencyRate).toFixed(2)}</strong>
                  </Typography>
                  <Typography sx={{ display: "flex", justifyContent: "space-between" }}>
                    <span>
                      <AccountBalanceWalletOutlined
                        sx={{ fontSize: 17, verticalAlign: "text-bottom", mr: 0.8 }}
                      />
                      Charges
                    </span>
                    <strong>{currencySymbol} {(totalCharges * currencyRate).toFixed(2)}</strong>
                  </Typography>
                  <Typography sx={{ display: "flex", justifyContent: "space-between" }}>
                    <span>
                      <CheckCircleOutline
                        sx={{ fontSize: 17, verticalAlign: "text-bottom", mr: 0.8 }}
                      />
                      Discounts
                    </span>
                    <strong style={{ color: discountTotal > 0 ? "#1f7a45" : undefined }}>
                      {discountTotal > 0 ? "−" : ""}{currencySymbol} {(discountTotal * currencyRate).toFixed(2)}
                    </strong>
                  </Typography>
                </div>

                <Divider sx={{ my: 1.2 }} />

                <Typography
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    fontSize: "1.85rem",
                    color: "#1f4ca6",
                    fontWeight: 900,
                  }}
                >
                  <span>Total</span>
                  <span>{currencySymbol} {(payableAmount * currencyRate).toFixed(2)}</span>
                </Typography>

                <Divider sx={{ my: 1.2 }} />

                <Typography sx={{ display: "flex", justifyContent: "space-between", mb: 0.6 }}>
                  <span>Payment Method</span>
                  <strong>{selectedPayment === "cash" ? "Cash" : "Card"}</strong>
                </Typography>
                {selectedPayment === "cash" && (
                  <>
                    <Typography sx={{ display: "flex", justifyContent: "space-between", mb: 0.6 }}>
                      <span>Cash Received</span>
                      <strong>
                        {currencySymbol} {toNumber(cashInput).toFixed(2)}
                      </strong>
                    </Typography>
                    <Typography
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        color: balance >= 0 ? "#1c7a43" : "#a23a3a",
                      }}
                    >
                      <span>Balance to Return</span>
                      <strong>
                        {currencySymbol} {Math.max(0, balance).toFixed(2)}
                      </strong>
                    </Typography>
                  </>
                )}
              </div>

              <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
                <div
                  id="print-standard-invoice"
                  style={{
                    width: "300px",
                    fontFamily: '"Sora", "Segoe UI", sans-serif',
                    color: "#111",
                    padding: "10px",
                  }}
                >
                  <div style={{ textAlign: "center", marginBottom: 8 }}>
                    <h3 style={{ margin: 0 }}>N-ACH POS</h3>
                    <div style={{ fontSize: "12px" }}>Standard Tax Invoice</div>
                  </div>
                  <div style={{ fontSize: "12px", marginBottom: 8 }}>
                    {cartId && <div>Invoice: {`#INV-${String(cartId).padStart(6, "0")}`}</div>}
                    <div>Date: {printedAt.toLocaleDateString()} {printedAt.toLocaleTimeString()}</div>
                    <div>Payment: {selectedPayment === "cash" ? "Cash" : "Card"}</div>
                  </div>
                  <hr />
                  <table style={{ width: "100%", fontSize: "12px", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={{ textAlign: "left" }}>Item</th>
                        <th style={{ textAlign: "right" }}>Qty</th>
                        <th style={{ textAlign: "right" }}>Rate</th>
                        <th style={{ textAlign: "right" }}>Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(items || []).map((item, index) => {
                        const qty = toNumber(item?.qty);
                        const unit = toNumber(item?.amt);
                        const offer = getItemOffer(dialogOffers, item, index);
                        return (
                          <tr key={`print-${item?.orderDetId || item?.prodDefId || item?.title}`}>
                            <td style={{ padding: "4px 0" }}>
                              {item?.title}
                              {offer && (
                                <div style={{ fontSize: "10px" }}>
                                  {offer.offerName || "Discount"}
                                  {offer.offerPercentage ? ` ${Number(offer.offerPercentage)}%` : ""}
                                  {" "}−{((Number(offer.savedAmount) || 0) * currencyRate).toFixed(2)}
                                </div>
                              )}
                            </td>
                            <td style={{ textAlign: "right" }}>{qty}</td>
                            <td style={{ textAlign: "right" }}>{(unit * currencyRate).toFixed(2)}</td>
                            <td style={{ textAlign: "right" }}>{(qty * unit * currencyRate).toFixed(2)}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <hr />
                  <div style={{ fontSize: "12px" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}><span>Subtotal</span><strong>{currencySymbol} {(apiSubtotal * currencyRate).toFixed(2)}</strong></div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}><span>Tax</span><strong>{currencySymbol} {(totalTax * currencyRate).toFixed(2)}</strong></div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}><span>Charges</span><strong>{currencySymbol} {(totalCharges * currencyRate).toFixed(2)}</strong></div>
                    <div style={{ display: "flex", justifyContent: "space-between" }}><span>Discounts</span><strong>{discountTotal > 0 ? "−" : ""}{currencySymbol} {(discountTotal * currencyRate).toFixed(2)}</strong></div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}><span>Total</span><strong>{currencySymbol} {(payableAmount * currencyRate).toFixed(2)}</strong></div>
                    {selectedPayment === "cash" && (
                      <>
                        <div style={{ display: "flex", justifyContent: "space-between" }}><span>Cash Received</span><strong>{currencySymbol} {toNumber(cashInput).toFixed(2)}</strong></div>
                        <div style={{ display: "flex", justifyContent: "space-between" }}><span>Balance to Return</span><strong>{currencySymbol} {Math.max(0, balance).toFixed(2)}</strong></div>
                      </>
                    )}
                  </div>
                  <hr />
                  <div style={{ textAlign: "center", fontSize: "11px" }}>Thank you for your purchase</div>
                </div>
              </div>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          sx={{
            px: { xs: 1.6, md: 3 },
            py: { xs: 1.4, md: 1.8 },
            borderTop: "1px solid #e6edf8",
            position: "sticky",
            bottom: 0,
            background: "rgba(255,255,255,0.95)",
            zIndex: 3,
            display: "grid",
            gap: 1,
            gridTemplateColumns: { xs: "repeat(2, minmax(0, 1fr))", sm: "repeat(3, minmax(0, 1fr))" },
          }}
        >
          <Button
            onClick={() => setOpenCheckoutDialog(false)}
            variant="outlined"
            sx={{
              textTransform: "none",
              borderRadius: 1.3,
              minWidth: 0,
              width: "100%",
            }}
          >
            Cancel
          </Button>
          <ReactToPrint
            trigger={() => (
              <Button
                variant="outlined"
                startIcon={<PrintOutlined />}
                sx={{
                  textTransform: "none",
                  borderRadius: 1.3,
                  minWidth: 0,
                  width: "100%",
                }}
              >
                Print
              </Button>
            )}
            content={() => document.getElementById("print-standard-invoice")}
          />
          <Button
            variant="contained"
            disableElevation
            sx={{
              textTransform: "none",
              minHeight: 44,
              color: "#ffffff",
              fontWeight: 700,
              opacity: 1,
              borderRadius: 1.4,
              minWidth: 0,
              width: "100%",
              gridColumn: { xs: "1 / -1", sm: "auto" },
            }}
            onClick={async () => {
              if (selectedPayment === "cash" && balance < 0) {
                toast.error("Payment is not sufficient to complete the transaction!", {
                  position: "bottom-right",
                });
                return;
              }

              try {
                await updateOrder({
                  orderHeadId: cartId,
                  paymentMethod: "cash",
                  orderType: 2,
                  custId: resolveCustomerId(),
                }).unwrap();
              } catch (error) {
                toast.error("Unable to complete payment right now. Please try again.", {
                  position: "bottom-right",
                });
                return;
              }

              window.dispatchEvent(
                new CustomEvent("pos:invoice-completed", {
                  detail: {
                    invoiceId: cartId,
                    total: Number((payableAmount * currencyRate).toFixed(2)),
                    paymentMethod: selectedPayment === "cash" ? "Cash" : "Card",
                    itemsCount: (items || []).reduce(
                      (sum, row) => sum + (parseFloat(row?.qty) || 0),
                      0
                    ),
                    timestamp: new Date().toISOString(),
                  },
                })
              );
              toast.success("Payment completed", { position: "bottom-right" });
              clearGlobalCartId();
              sessionStorage.removeItem("posCustomer");
              dispatch(clearSelectedCustomer());
              window.dispatchEvent(
                new CustomEvent("pos:customer-changed", {
                  detail: { customer: null },
                })
              );
              window.dispatchEvent(
                new CustomEvent("pos:cart-id-changed", {
                  detail: { cartId: null },
                })
              );
              setOpenCheckoutDialog(false);
            }}
            startIcon={<CheckCircleOutline />}
            style={{
              background: "linear-gradient(135deg, #1f4ca6 0%, #2f6bff 100%)",
            }}
          >
            Complete
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default OrderSummery;
